import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { State } from 'xstate';
import { Button } from '~/components/button';
import { config as membershipConfig } from '~/funnels/membership/config';
import { currentUrl } from '~/utils/redirects';
import { store } from '~/utils/store';

const query = gql`
  query Flex_DemoResumingUrls($path: String, $queryParams: String, $userId: Int!) {
    user(id: $userId) {
      redirectUrl(app: funnel, path: $path, queryParams: $queryParams)
    }
  }
`;

type Props = {
  clearAndReload: (url?: string) => void;
  currentState?: State<any>;
};

export const ResumingButtons = ({ clearAndReload, currentState }: Props) => {
  const matches = currentState?.matches || (() => false);
  const context = currentState?.context;
  const userId =
    context?.user?.id || context?.funnelPacket?.user?.id || context?.userId || store.get('USER_ID');
  const accountId =
    context?.user?.accountId || context?.funnelPacket?.account?.id || store.get('ACCOUNT_ID');

  const [getResumingUrl, { data: resumingData }] = useLazyQuery(query, {
    variables: { queryParams: `accountId=${accountId}`, userId, path: '/' },
  });
  const redirect = data => {
    const url = data?.user?.redirectUrl;
    const cu = currentUrl();
    if (url) {
      // running against staging gryphon locally
      if (
        (cu.includes('localhost:') ||
          cu.includes('dev.arcadia.com') ||
          cu.includes('dev.perchenergy.com')) &&
        url.includes('staging.')
      ) {
        clearAndReload(`${cu}${url.split('.com')[1]}`);
      } else {
        clearAndReload(url);
      }
    }
  };

  useEffect(() => {
    redirect(resumingData);
  }, [resumingData]); // eslint-disable-line react-hooks/exhaustive-deps

  if (matches('utility') || matches('account') || matches('user')) return null;
  return (
    <>
      <Button
        onClick={() =>
          getResumingUrl({
            variables: { queryParams: `accountId=${accountId}`, userId, path: '/' },
          })
        }
        title="Simulates logging out and logging back in from Sphinx"
      >
        Resume funnel
      </Button>
      {location.pathname === membershipConfig.path && (
        <Button
          onClick={() =>
            getResumingUrl({
              variables: {
                queryParams: 'reason=billPayAvailable',
                userId,
                path: '/dashboard',
              },
            })
          }
          title="Simulates coming directly from Lovebird"
        >
          Dashboard Billpay upgrade
        </Button>
      )}
    </>
  );
};
